import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { RebootLog } from '../types/reboot-log';

@Component({
  selector: 'reboots',
  template: `<hubs-sub-menu></hubs-sub-menu>
  <ul class="reboots">
    <li>
      <span (click)="later()" class="created center">Newer</span>
      <span class="hubid">Hub ID</span>
      <span class="version">Version</span>
      <span class="cause">Cause</span>
      <span class="timezone">Timezone</span>
      <span class="wifi_version">Wifi Version</span>
      <span class="traces">Traces</span>
    </li>
    <li *ngFor="let reboot of reboots"
        (click)="gotoDetail(reboot)">
      <span class="created">{{reboot.created | godate}}</span>
      <span class="hubid">{{reboot.hubid}}</span>
      <span class="version">{{reboot.os_version}}</span>
      <span class="cause">{{reboot.reset_cause}}</span>
      <span class="timezone">{{reboot.timezone}}</span>
      <span class="wifi_version">{{reboot.wifi_version}}</span>
      <span class="traces">{{reboot.traces}}</span>
    </li>
    <li>
      <span (click)="earlier()" class="created center">Older</span>
      <span class="hubid">Hub ID</span>
      <span class="version">Version</span>
      <span class="cause">Cause</span>
      <span class="timezone">Timezone</span>
      <span class="wifi_version">Wifi Version</span>
      <span class="traces">Traces</span>
    </li>
  </ul>
  `,
  styles: [
    `.selected { background-color: #CFD8DC !important; color: white; }`,
    `.reboots {margin: 0 0 2em 0;list-style-type: none;padding: 0;width: 100%;}`,
    `.reboots li {display: block;background-color: #EEE;margin: 0.2em 0;padding: 0;}`,
    `.reboots li.selected:hover {background-color: #BBD8DC !important;color: white;}`,
    `.reboots li:hover {color: #607D8B;background-color: #DDD;left: .1em;}`,
    `.reboots li span.created {display: inline-block;color: white;padding: 0.7em;vertical-align: top;background-color: #607D8B;width: 10em;}`,
    `.hubid {display: inline-block;padding: 0.7em;width: 4em;}`,
    `.version {display: inline-block;padding: 0.7em;width: 6em;  }`,
    `.cause {display: inline-block;padding: 0.7em;width: 3em;  }`,
    `.timezone {display: inline-block;padding: 0.7em;width: 8em;  }`,
    `.wifi_version {display: inline-block;padding: 0.7em;width: 6em;  }`,
    `.traces {display: inline-block;padding: 0.7em;width: 24em;  }`,
  ],
  providers: [HubService],
})

export class RebootsComponent implements OnInit {
  reboots: RebootLog[];
  hubID: number;
  private fromTimestamps: string[] = <string[]>[];
  errorMessage: string;

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('rebootsComponent Error: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    document.getElementById('title').innerText = 'All reboots';
    this.route.params.pipe(
      switchMap((params: Params) => this.switchedHub(params['hubid']))
    ).subscribe();
  }

  switchedHub(hubID: number): Observable<number> {
    console.log('Switched HUB: ' + hubID);
    this.hubID = hubID;
    this.fromTimestamps = <string[]>[];
    this.later();
    return of(this.hubID);
  }

  newrebootLogs(reboots: RebootLog[]): void {
    let updated = <RebootLog[]>[];
    for (let g of reboots) {
      updated.push(g);
      console.log(g.created + ': ' + g.hubid + ' - ' + g.reset_cause);
    }
    this.reboots = updated;
  }

  earlier(): void {
    let created: string = null;
    try {
      created = this.reboots[this.reboots.length - 1].created;
      if (!this.fromTimestamps) {
        this.fromTimestamps = <string[]>[];
      }
      this.fromTimestamps.push(this.reboots[0].created);
    } catch (err) {
      console.log(err);
    }
    this.hubService.getRebootLogs(+this.hubID, created, 20)
      .subscribe(
        (values: RebootLog[]) => this.newrebootLogs(values),
        (err: any) => RebootsComponent.handleRefreshError(err)
      );
  }

  later(): void {
    let created: string = null;
    if (this.fromTimestamps.length > 0) {
      try {
        created = this.fromTimestamps[this.fromTimestamps.length - 1];
        this.fromTimestamps = this.fromTimestamps.slice(0, -1);
      } catch (err) {
        console.log(err);
      }
    }
    this.hubService.getRebootLogs(+this.hubID, created, 20)
      .subscribe(
        (values: RebootLog[]) => this.newrebootLogs(values),
        (err: any) => RebootsComponent.handleRefreshError(err)
      );
  }

  gotoDetail(reboot: RebootLog): void {
    this.router.navigate(['/hub', reboot.hubid]);
  }

}

